module.exports = __webpack_public_path__ + "img/werksplan-anlegen.c33bcce1.gif";